// extracted by mini-css-extract-plugin
export default {"container":"ServiceInformation_container__oVfHx","item":"ServiceInformation_item__+rgjm","itemImage":"ServiceInformation_itemImage__uRwGH","image":"ServiceInformation_image__fXGPH"};